import { Component, Input } from '@angular/core';
import { MyCompetitionWordCloudResponse } from '../../../components/my-competition-screen/types';
import { WordCloudCardComponent } from './word-cloud-card/word-cloud-card.component';
import { NoWidgetDataComponent } from '../../../components/my-brand-screen/no-widget-data/no-widget-data.component';
import { CommonModule } from '@angular/common';
import {LoaderComponent} from '../loader/loader.component';

@Component({
  selector: 'app-word-cloud',
  imports: [
    WordCloudCardComponent,
    NoWidgetDataComponent,
    CommonModule,
    LoaderComponent
  ],
  templateUrl: './word-cloud.component.html',
  styleUrl: './word-cloud.component.scss'
})
export class WordCloudComponent {
  @Input() data?: MyCompetitionWordCloudResponse;
  @Input() brandColors?: Record<string, string>;
  @Input() brandWidthMap?: Record<string, number>;
  @Input() loading = false;
}
